<template>
  <div class="page-content congrats">
    <div class="congrats__container">
      <img class="bg-image" src="@/assets/images/final-bg.png" alt="image description" aria-hidden="true">
      <div class="congrats__heading">
        <h1>Congratulations!</h1>
          <p>Tally your points to determine the winner.
            <br>Play again to try to beat your score.
            <br>Or challenge your family and friends!</p>
      </div>
      <div class="congrats__content">
        <div class="congrats__text">
            <a href="#" class="btn-next" @click="restartApp">
              <span>Play again </span>
            </a>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
  import { mapMutations } from "vuex"

  export default {
    name: "Congrats",
    components: {
    },
    data() {
      return {
        confettiOptions: {
          colors: ['var(--yellow)', 'var(--red)', 'var(--blue)', 'var(--gray)', 'var(--blue-light)']
        },
        isVisible: false,
        screenHeight: 0,
        screenWidth: 0
      }
    },
    methods: {
      ...mapMutations({
        restartApp() {
          window.location.reload();
        },
        play: 'play'
      }),
      goToNextStep() {
        this.next();
      }
    },
    mounted() {
      this.play('congrats')
      this.isVisible = true
      this.screenHeight = window.innerHeight * 2
      this.screenWidth = window.innerWidth * 2
      window.dispatchEvent(new Event('resize'));
    }
  }
</script>
